module.exports = __webpack_public_path__ + "img/7.65fe9061.jpg";